import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
interface IProps {
    slug: string;
    text?: string;
}
export const ButtonLink = (props: IProps) => {
    const handleClick = () => {
        pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.OFFER_BUTTON_CLICK);
        window.location.href = rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${props.slug}`});
    };

    return (
        <Button variant="filled_primary" type="button" onClick={handleClick}>
            <Text variant="button_big">{props.text || "sprawdź aktualne oferty"}</Text>
        </Button>
    );
};
import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
interface IProps {
    slug: string;
    text?: string;
}
export const ButtonLink = (props: IProps) => {
    const handleClick = () => {
        pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.OFFER_BUTTON_CLICK);
        window.location.href = rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${props.slug}`});
    };

    return (
        <Button variant="filled_primary" type="button" onClick={handleClick}>
            <Text variant="button_big">{props.text || "sprawdź aktualne oferty"}</Text>
        </Button>
    );
};
